import React,{useCallback, useEffect, useRef, useState} from 'react'
import './SHeader.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { LoginService } from '../services/LoginService';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';

import { Divider } from 'primereact/divider';
import { fetchDoctorDatasss } from '../reduxactions/suprivisoractions/SuprivisorProfileActions';
import eventBus from '../doctorapprover/eventBus';
type Nullable<T> = T | null;

var imageuser = require('../assets/img/medi.png');
var projecticon = require('../assets/img/medicaaal.png');
var defaultimage = require('../assets/img/images.png');





export const SHeader = () => {
    const op = useRef(null as any);
    const photos = window.sessionStorage.getItem('photo');
    const uid = window.sessionStorage.getItem('uid');
  
  
  
    const imgSrc =  imageuser;
  
    const usertype = window.sessionStorage.getItem('usertype');
    const username = window.sessionStorage.getItem('username');

    const [photo,setPhoto]=useState<any>(null);
    useEffect(()=>{
      if(photos !== photo){
        const photos = window.sessionStorage.getItem('photo');
        setPhoto(photos);
      }
    },[setPhoto,photo,photos]);
    const fetchSessionPhoto = useCallback(async () => {
      try {
        const photoUrl = window.sessionStorage.getItem('photo');
        setPhoto(photoUrl);
      } catch (error) {
        console.error('Error fetching session photo:', error);
      }
    }, []);
    useEffect(() => {
      const handlePhotoUpdate = (newPhoto:any) => {
        setPhoto(newPhoto);
      };
      eventBus.on('photoUpdated', handlePhotoUpdate);
  
      return () => {
        eventBus.off('photoUpdated', handlePhotoUpdate);
      };
    }, []);
    
    useEffect(() => {
      fetchSessionPhoto();
    
      const handleStorageChange = () => {
        if (window.sessionStorage.getItem('photo') !== photo) {
          fetchSessionPhoto();
        }
      };
    
      window.addEventListener('storage', handleStorageChange);
    
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, [fetchSessionPhoto, photo]);
    const handleLogout = () => {
      window.sessionStorage.removeItem('usertype');
    };
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.sprofile.data);
      const fetchDataAsync = async () => {
          try {
              await dispatch(fetchDoctorDatasss(uid) as any);
          } catch (error) {
              console.error('Error fetching data:', error);
          }
      };
      useEffectOnce(() => {
      fetchDataAsync();
  }, [dispatch]);
  



  return (

    <div className="layout-topbar" style={{ backgroundColor: '#26b4c9', color: 'white', display: 'flex', alignItems: 'center' }}>
      <div className="layout-topbar-logo" style={{ flex: 1 }}>
        <span>
        <img src={imageuser} alt="Logo" width="50px" height="100%" />
        <img src={projecticon} alt="Logo" width="200px" height="100%" />
        </span>
        
      </div>
    
    
          <a  className="nav-link"  onClick={(e) => op.current.toggle(e)} style={{textDecoration: 'none', marginLeft: '15px',float:'right'}}>
          <img src={photo || defaultimage} className="avatar" alt="User Image" />
            <span className="hidden-xs" style={{color: 'white', fontSize: '1.2rem',fontWeight:'400',fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',marginLeft:'10px'}}>{username} - {usertype}</span>
          </a>
    
      <ul className="navbar-nav ml-auto">
        <OverlayPanel ref={op}>
          <div className="dropdown-divider"></div>
          <a className="dropdown-item" style={{textDecoration: 'none'}}>
            <div className="media">
            <a href={`${process.env.PUBLIC_URL}/supprofile`} style={{ textDecoration: 'none' }}>Profile</a>
                <Divider />
                <a href={`${process.env.PUBLIC_URL}/supresetpassword`} style={{ textDecoration: 'none' }}>Reset</a>
                <Divider />
                 {/* <a href={`${process.env.PUBLIC_URL}/vresetpassword`} style={{ textDecoration: 'none'}}>Reset Password</a> */}
              {/* <a href="/supprofile" style={{textDecoration: 'none'}}>Profile</a>
              <Divider /> */}
              {/* <a href="/s" style={{textDecoration: 'none'}}>Reset Password</a> */}
              {/* <Divider /> */}
              <a href="/" style={{textDecoration: 'none'}}>Sign out</a>
              </div>
              </a>
        </OverlayPanel>
      </ul>
    </div>
    

    );
};

SHeader.displayName = 'AppTopbar';

export default SHeader;

